// import moment from 'moment'

export default {
  getSubgeofences (VueApp, id, callback) {
    VueApp.$sdk.get('/airports/' + id + '/subgeofences', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        // set StagingLots Data
        let stagingData = []
        res.staging.forEach(function (data) {
          stagingData.push({ id: data.id, name: data.name })
        })
        VueApp.$store.commit('geofences/setAirportSubgeofence', {
          field: 'stagingLots',
          id: id,
          value: stagingData
        })

        // set RestrictedArea Data
        let restrictedData = []
        res.restricted.forEach(function (data) {
          restrictedData.push({ id: data.id, name: data.name })
        })
        VueApp.$store.commit('geofences/setAirportSubgeofence', {
          field: 'restrictedAreas',
          id: id,
          value: restrictedData
        })

        // set ServiceArea Data
        let serviceData = []
        res.restricted.forEach(function (data) {
          serviceData.push({ id: data.id, name: data.name })
        })
        VueApp.$store.commit('geofences/setAirportSubgeofence', {
          field: 'serviceAreas',
          id: id,
          value: serviceData
        })
      }
      callback(res)
    })
  },
  updateSubGeofence (VueApp, data, callback) {
    VueApp.$sdk.post('/airports/' + data.id + '/subgeofences', {
      token: VueApp.$store.state.session.sessionToken,
      priority: data.priority
    }, res => {
      callback(res)
    })
  },
  addSubGeofence (VueApp, data, callback) {
    VueApp.$sdk.post('/airports/' + data.id + '/subgeofences/' + data.subID, {
      token: VueApp.$store.state.session.sessionToken,
      priority: data.priority
    }, res => {
      callback(res)
    })
  },
  removeSubGeofence (VueApp, data, callback) {
    VueApp.$sdk.delete('/airports/' + data.id + '/subgeofences/' + data.subID, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/geofences/airport.js